import { gql } from '@apollo/client';
import { surfaceUnionIdFragment } from 'graphql/surface-node/fragments/surface-node-fragment';

export const surfaceNodeDeletedSubscription = gql`
  subscription surfaceNodeDeleted($surface: ID!) {
    surfaceNodeDeleted(surface: $surface) {
      ...surfaceNodeUnionId
    }
  }
  ${surfaceUnionIdFragment}
`;
